import { useI18n } from "@/i18n/translations";
import { pubblicazioni } from "@/data/publicazioni";

/** Titoli di sezione bibliografica: le voci restano verbatim (convenzione), i titoli di sezione si localizzano. */
const PUBB_TITOLI_EN: Array<[RegExp, string]> = [
  [/^volumi in collaborazione/i, "Co-authored volumes"],
  [/^volumi curati/i, "Edited volumes"],
  [/^volumi a cura/i, "Edited volumes"],
  [/^volumi tradotti/i, "Volumes translated and published abroad"],
  [/^volumi/i, "Volumes"],
];
const pubTitolo = (titolo: string, l: string) => (l === "en" ? PUBB_TITOLI_EN.find(([re]) => re.test(titolo))?.[1] ?? titolo : titolo);

import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/Editorial";
import { Reveal } from "@/components/Reveal";

export const Pubblicazioni = () => {
  const { t, lang } = useI18n();
  return (
    <>
      <Seo titleKey="seo.pubblicazioni.title" descKey="seo.pubblicazioni.desc" path="/attivita/pubblicazioni" />
      <PageHeader kickerKey="att.kicker" titleKey="att.pubblicazioni_title">
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-mutedtx">{t("att.pubblicazioni_intro")}</p>
      </PageHeader>
      <div className="container-x pb-20 sm:pb-24" data-testid="publications-archive-container">
        <div className="space-y-12" data-testid="pubblicazioni-list">
          {pubblicazioni.map((a) => (
            <div key={a.autore}>
              <Reveal>
                <h2 className="font-serif text-2xl font-medium text-ink">{a.autore}</h2>
              </Reveal>
              {a.sezioni.map((s) => (
                <div key={s.titolo} className="mt-4">
                  <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-bordeaux">{pubTitolo(s.titolo, lang)}</p>
                  <ul className="mt-2 space-y-1.5">
                    {s.voci.map((v, i) => (
                      <li key={i} className="border-b border-borderc/60 pb-1.5 text-sm leading-relaxed text-bodytx/85" data-testid={`pubblicazione-${a.autore.split(" ")[0]}-${i}`}>
                        {v}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Pubblicazioni;
